module.exports = __webpack_public_path__ + "media/images/athletes/1079-c1a8980a51241ae47c3b14888659aecb.png";